// Matomo lead events. Pushed to window._paq; the MTM container
// (inc/matomo.php) registers its tracker as default, so the queue is
// sent once the container loads. Events are queued only while
// CookieYes reports Analytics consent – nothing recorded before
// consent (or after withdrawal) can be replayed.

// Contact page from Theme Options → Contact, localized in functions.php.
const CONTACT_PATH = window.kcaData?.contactPath ?? '/contact-us';
const FORM_DEDUPE_MS = 2000;

const PAGE_LABELS = [
  ['home', 'Contact us button – homepage'],
  ['single-product', 'Contact us button – product page'],
  ['tax-product_category', 'Contact us button – category page'],
  ['error404', 'Contact us button – 404'],
];

// Fails closed: no CookieYes API means no consent.
const hasAnalyticsConsent = () => typeof window.getCkyConsent === 'function'
  && window.getCkyConsent()?.categories?.analytics === true;

const track = (category, action, name) => {
  if (!hasAnalyticsConsent()) return;
  /* eslint-disable no-underscore-dangle */
  window._paq = window._paq || [];
  window._paq.push(['trackEvent', category, action, name]);
  /* eslint-enable no-underscore-dangle */
};

const isContactLink = (link) => link.hostname === window.location.hostname
  && link.pathname.replace(/\/$/, '') === CONTACT_PATH;

const contactLabel = (link) => {
  if (link.closest('.site-header, .site-nav-mobile')) {
    return 'Contact us – header';
  }
  if (link.closest('.site-footer')) {
    return 'Contact us – footer';
  }
  const page = PAGE_LABELS
    .find(([bodyClass]) => document.body.classList.contains(bodyClass));
  return page ? page[1] : 'Contact us – other';
};

// 1. HubSpot form (iframe) – new embed and legacy embed. Both may fire
// for one submission, hence the dedupe window.
let lastFormSubmit = 0;
const trackFormSubmit = () => {
  const now = Date.now();
  if (now - lastFormSubmit < FORM_DEDUPE_MS) return;
  lastFormSubmit = now;
  track('Lead', 'Form submitted', 'Contact page');
};

window.addEventListener(
  'hs-form-event:on-submission:success',
  trackFormSubmit,
);
// Legacy embed posts either from the page itself (forms script, or its
// src-less iframe) or from a HubSpot-hosted iframe embedded on the page.
const HS_ORIGIN = /^https:\/\/([\w-]+\.)*(hsforms\.(com|net)|hubspot\.com)$/;

const isHubSpotMessage = ({ origin, source }) => {
  if (origin !== window.location.origin && !HS_ORIGIN.test(origin)) {
    return false;
  }
  return source === window || [...document.querySelectorAll('iframe')]
    .some((frame) => frame.contentWindow === source);
};

window.addEventListener('message', (event) => {
  const { data } = event;
  if (data?.type === 'hsFormCallback'
    && data.eventName === 'onFormSubmitted'
    && isHubSpotMessage(event)) {
    trackFormSubmit();
  }
});

// 2. "Contact us" CTA and 3. mailto clicks.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;

  if (link.protocol === 'mailto:') {
    const email = decodeURIComponent(link.href.slice(7).split('?')[0]);
    track('Lead', 'Email click', email);
    return;
  }

  if (isContactLink(link)) {
    track('CTA', 'Contact click', contactLabel(link));
  }
});
